import React from 'react';
import { Provider } from 'react-redux';
import { reduxBatch } from '@manaflair/redux-batch';
import { createStore, applyMiddleware, compose } from 'redux';
import PropTypes from 'prop-types';
import thunk from 'redux-thunk';
import BetFeedWidgetContainer from './containers/BetFeedWidgetContainer';
import BetFeedReducer from './reducers/betfeedWidgetReducers';
import { initialState } from '../app/initialState';
import { isIE } from '../../../shared/utils/win';

import '../styles/betfeed-widget.scss';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const propTypes = {
    sportSlug: PropTypes.string,
    sportName: PropTypes.string,
    displayType: PropTypes.string,
};

class BetFeedWidget extends React.Component {

    constructor(props) {
        super(props);
        this.store = createStore(
            BetFeedReducer,
            {
                betcards: {
                    ...initialState,
                    sportName: this.props.sportName,
                    sportSlug: this.props.sportSlug,
                    displayType: this.props.displayType,
                },
            },

            composeEnhancers(
                applyMiddleware(thunk),
                reduxBatch
            )
        );
    }

    render() {
        if (isIE()) {
            return null;
        }

        return <Provider store={this.store}>
            <BetFeedWidgetContainer
                sportName={this.props.sportName}
                sportSlug={this.props.sportSlug}
                displayType={this.props.displayType}
            />
        </Provider>;
    }
}

BetFeedWidget.propTypes = propTypes;

export default BetFeedWidget;
